import { PriceProtectionEnum } from '@talos/kyoko';
import { OrgConfigurationKey, useOrgConfiguration } from '../providers/OrgConfigurationProvider';

export const usePriceProtection = () => {
  const { getConfig } = useOrgConfiguration();
  // If 1 (or value > 0) then price protection is disabled.
  const isPriceProtectionDisabledOrgLevel = getConfig(OrgConfigurationKey.OMSPriceProtectionDisabled, 0) > 0;

  // This is supposed to be a fallback value if the strategy_parameter does not have default_value.
  const defaultPriceProtection = isPriceProtectionDisabledOrgLevel
    ? PriceProtectionEnum.Disabled
    : PriceProtectionEnum.Error;

  return { isPriceProtectionDisabledOrgLevel, defaultPriceProtection };
};
